export default "__VITE_ASSET__bae3175a__"